<template>
  <div class="popup">

    <div class="popupContainer">
        <div class="closePopup" @click="okanMain.popup = null"></div>
        <div class="content" v-html="okanMain.popup"></div>
    </div>

    
  </div>
</template>

<script>
export default {
  name: 'popup',
  props: {
    okanMain: Object,
  },
  methods: {
    
  }
}
</script>

